import Provider from "./src/context/Context"

export const wrapRootElement = Provider
